import clsx from 'clsx';
import { Check } from 'lucide-react';

export default function Checkbox({ label, checked, onChange, className = '', ...props }) {
  return (
    <label className={clsx('flex items-center gap-2 cursor-pointer', className)}>
      <div className="relative">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className="sr-only"
          {...props}
        />
        <div
          className={clsx(
            'w-5 h-5 border-2 rounded transition-all',
            checked
              ? 'bg-primary border-primary'
              : 'bg-white border-gray-300 hover:border-primary'
          )}
        >
          {checked && (
            <Check className="w-4 h-4 text-white absolute top-0 left-0" strokeWidth={3} />
          )}
        </div>
      </div>
      {label && <span className="text-sm text-gray-700">{label}</span>}
    </label>
  );
}
